export const getRuntimeEnvironment = () => {
  const env = process.env.NEXT_PUBLIC_APP_ENV || "production";
  return {
    isLocal: env === "development" || env === "local",
    isStaging: env === "staging",
    isProduction: env === "production",
  };
};
